<cmx-datepicker (select)="activateFilter( $event )" (cancel)="removeFilter()" [rtl]="isRtl"></cmx-datepicker>